import google from './images/google.png';
import azure from './images/microsoft-azure.png';
import microsoftStartup from './images/microsoft-startup.png';
import nvidia from './images/nvidia.png';
import elevenLabs from './images/eleven-labs.png';
import { useEffect, useState, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';

const BackedBy = () => {
  const [isMobile, setIsMobile] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const controls = useAnimation();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const backers = [google, azure, microsoftStartup, nvidia, elevenLabs];
  const doubledBackers = [...backers, ...backers];

  const startScrollAnimation = () => {
    if (containerRef.current) {
      controls.start({
        x: [0, -containerRef.current.scrollWidth / 2],
        transition: {
          duration: 15,
          repeat: Infinity,
          ease: 'linear',
          repeatType: 'loop',
        },
      });
    }
  };

  useEffect(() => {
    if (isMobile) {
      startScrollAnimation();
    }
  }, [isMobile]);

  return (
    <div className="bg-background-main py-24 overflow-hidden">
      <div className="text-text-secondary font-normal text-center text-sm mb-8">
        BACKED BY
      </div>

      {isMobile ? (
        <div className="relative w-full overflow-hidden">
          <motion.div ref={containerRef} className="flex" animate={controls}>
            {doubledBackers.map((backer, index) => (
              <motion.div
                key={index}
                className="flex-shrink-0 mx-4"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <img
                  src={backer}
                  alt={`Backer ${index + 1}`}
                  className="h-8 w-auto object-contain invert dark:invert-0"
                />
              </motion.div>
            ))}
          </motion.div>
        </div>
      ) : (
        <motion.div className="flex justify-center items-center gap-8 h-12">
          {backers.map((backer, index) => (
            <motion.img
              key={index}
              src={backer}
              alt={`Backer ${index + 1}`}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              className="invert dark:invert-0"
            />
          ))}
        </motion.div>
      )}
    </div>
  );
};

export default BackedBy;
